module.exports = __webpack_public_path__ + "static/media/price-icon100.325ee815.png";